export const isNumber = (value: any) => typeof value === 'number' || !Number.isNaN(parseFloat(value));
